import {Component} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer, Title} from '@angular/platform-browser';
import {environment} from '@environment';
import {LoginService, NavigationRoute$, User$,WebClient} from '@injectables';
import { combineLatest, filter, op, Subscription } from '@lib/rxjs';
import { WebsocketService } from './new-ui/video-streaming/websocket.service';
import { SupportButtonService } from '../injectables/support-button.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent{
	constructor(
		iconRegistry:MatIconRegistry,
		sanitizer:DomSanitizer,
		title:Title,
		private readonly webClient:WebClient,
		public readonly user$:User$,
		private readonly route$: NavigationRoute$,
		private websocketService: WebsocketService,
		private loginservice: LoginService,
		private router: Router,
		public readonly supportButton: SupportButtonService,
	) {
		this.handleLoginRedirect();
		title.setTitle(environment.appTitle);
		iconRegistry.setDefaultFontSetClass("material-icons-outlined");
		iconRegistry.addSvgIcon('strayos',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/strayos.svg'));
		iconRegistry.addSvgIcon('strayos_blue',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/strayos_blue.svg'));
		iconRegistry.addSvgIcon('strayos_white',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/strayos_white.svg'));
		iconRegistry.addSvgIcon('home',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/home.svg'));
		iconRegistry.addSvgIcon('analysis',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/analysis.svg'));
		iconRegistry.addSvgIcon('settings',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/settings.svg'));
		iconRegistry.addSvgIcon('checked-blue',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/checked-blue.svg'));
		iconRegistry.addSvgIcon('warn-red',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/warn-red.svg'));
		iconRegistry.addSvgIcon('edit',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/edit.svg'));
		iconRegistry.addSvgIcon('edit-accent',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/edit-accent.svg'));
		iconRegistry.addSvgIcon('empty-data',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/empty-data.svg'));
		iconRegistry.addSvgIcon('trash',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/trash.svg'));
		iconRegistry.addSvgIcon('back-primary',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/back-primary.svg'));
		iconRegistry.addSvgIcon('file-primary',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/file-primary.svg'));
		iconRegistry.addSvgIcon('file',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/file.svg'));
		iconRegistry.addSvgIcon('arrow-down-accent',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/arrow-down-accent.svg'));
		iconRegistry.addSvgIcon('user-preference-accent',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/user-preference-accent.svg'));
		iconRegistry.addSvgIcon('user-preference-primary',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/user-preference-primary.svg'));
		iconRegistry.addSvgIcon('product-release-notes',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/product-release-notes.svg'));
		iconRegistry.addSvgIcon('chat-white',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/chat-white.svg'));
		iconRegistry.addSvgIcon('download-white',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/download-white.svg'));
		iconRegistry.addSvgIcon('arrow-left-white',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/arrow-left-white.svg'));
		iconRegistry.addSvgIcon('arrow-right-white',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/arrow-right-white.svg'));
		iconRegistry.addSvgIcon('checked-white',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/checked-white.svg'));
		iconRegistry.addSvgIcon('csv',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/csv.svg'));
		iconRegistry.addSvgIcon('pdf',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/pdf.svg'));
		iconRegistry.addSvgIcon('mail',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/mail.svg'));
		iconRegistry.addSvgIcon('reset-successful',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/reset-successful.svg'));
		iconRegistry.addSvgIcon('refresh-white',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/refresh-white.svg'));
		iconRegistry.addSvgIcon('db',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/db.svg'));
		iconRegistry.addSvgIcon('db-accent',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/db-accent.svg'));
		iconRegistry.addSvgIcon('api',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/api.svg'));
		iconRegistry.addSvgIcon('psd',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons-v2/psd.svg'));
		iconRegistry.addSvgIcon('psd-primary',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/psd-primary.svg'));
		iconRegistry.addSvgIcon('shift',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons-v2/shift.svg'));
		iconRegistry.addSvgIcon('location',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/pin.svg'));
		iconRegistry.addSvgIcon('area',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/area.svg'));
		iconRegistry.addSvgIcon('cube',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/cube.svg'));
		iconRegistry.addSvgIcon('play',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons-v2/play.svg'));
		iconRegistry.addSvgIcon('warn-yellow',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/warn-yellow.svg'));
		iconRegistry.addSvgIcon('score',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/score.svg'));
		iconRegistry.addSvgIcon('netra-icon',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/netra_icon_only.svg'));
		iconRegistry.addSvgIcon('netralogin',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/netralogin.svg'));
		iconRegistry.addSvgIcon('netraloginimg',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/netraloginimg.svg'));
		iconRegistry.addSvgIcon('muckpile',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/muckpile.svg'));		
		iconRegistry.addSvgIcon('muckpile-blue',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/muckpile-blue.svg'));		
		iconRegistry.addSvgIcon('muckpile-tag',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/muckpile_tag.svg'));		
		iconRegistry.addSvgIcon('filter',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/filter.svg'));
		iconRegistry.addSvgIcon('timeline-chunk',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/time-line-chunk.svg'));
		iconRegistry.addSvgIcon('vehicle',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/vehicle.svg'));
		iconRegistry.addSvgIcon('camera',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/camera.svg'));
		iconRegistry.addSvgIcon('full-screen-white', sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/full-screen-white.svg'));
		iconRegistry.addSvgIcon('full-screen-blue', sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/full-screen-blue.svg'));
		iconRegistry.addSvgIcon('download-blue', sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/download-blue.svg'));
		iconRegistry.addSvgIcon('psd-white',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/psd-white.svg'));
		iconRegistry.addSvgIcon('manual-draw',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/manual-draw.svg'));
		iconRegistry.addSvgIcon('geojson',sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/geojson.svg'));

		
		this.user$.subscribe(user => {
			if (user) {
				this.websocketService.connect(user.id.toString());
			}
		})
	}

	private loginRedirectSub = new Subscription();
	private handleLoginRedirect(): void {
		this.loginRedirectSub = combineLatest([
			this.router.events.pipe(filter(e => e instanceof NavigationEnd)),
			this.user$.pipe(filter(user => user !== undefined))
		]).subscribe(([event, user]) => {
			const currentUrl = (event as NavigationEnd).urlAfterRedirects;
			if (!user) {
				this.router.navigate(['/login']);
			} else if (currentUrl === '/login' && user) {
				this.router.navigate(['/home']);
			}
		});
	}

	ngOnDestroy(): void {
		this.loginRedirectSub.unsubscribe();
	}

	public readonly serverReachable$=this.webClient.serverReachable$;
	public readonly type$ = this.route$.pipe(
		op.map(route => route[0]),
	);

	public dragging = false;
	public onSupportClick(): void {
		if (this.dragging) {
			this.dragging = false;
			return;
		}
		this.supportButton.toggle();
	}
}
